'use client';

import { useEffect } from 'react';

import { install } from '@crehana/devtools';

export const Devtools: React.FC = () => {
  useEffect(() => {
    install();
  }, []);
  return null;
};
